export class AddressDto {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4: string;
  postcode: string;
  county: string;
  country: string;

  constructor(
    addressLine1: string,
    addressLine2: string,
    addressLine3: string,
    addressLine4: string,
    postcode: string,
    county: string,
    country: string
  ) {
    this.addressLine1 = addressLine1;
    this.addressLine2 = addressLine2;
    this.addressLine3 = addressLine3;
    this.addressLine4 = addressLine4;
    this.postcode = postcode;
    this.county = county;
    this.country = country;
  }
}
